<template>
  <StepPanel>
    <div class="flex flex-col justify-center min-h-[420px] gap-8">
      <div class="flex flex-col gap-5">
        <UiText
          as="p"
          class="font-normal font-archivo text-primary tracking-10p"
          text="JOIN OUR NETWORK"
        />
        <UiText
          as="h1"
          class="font-normal text-primary leading-tight"
          text="Wanna join our expert network?"
        />
        <UiText
          as="p"
          class="text-primary max-w-md"
          text="We are currently reviewing new expert applications by email. Send us a short note about what you do, who you help, and a link to your work."
        />
      </div>

      <div class="flex flex-col gap-3">
        <a
          class="flex items-center justify-center rounded-md bg-primary px-5 py-3 text-center font-medium text-white transition-opacity hover:opacity-90"
          href="mailto:hello@shopexperts.com"
        >
          Email hello@shopexperts.com
        </a>
        <UiText
          as="p"
          class="text-sm text-primary/70"
          text="We will get back to you if there is a fit."
        />
      </div>
    </div>
  </StepPanel>
</template>

<script setup lang="ts">
import StepPanel from "./StepPanel.vue";
import { UiText } from "@shopexperts/shared";
</script>
